import { StyleSheet } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: CARD_SIZE => ({
    width: CARD_SIZE,
    marginBottom: 5,
    borderWidth: 0,
    maxWidth: 400
  }),
  card: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    padding: 20,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
    elevation: 2,
  }),
  name: {
    ...Fonts.type.bold,
    fontSize: 18,
  },
  address: {
    marginTop: 12,
    fontSize: 15,
  },
  additionalInfo: theme => ({
    color: theme.colors.subtitle,
  }),
  calendarContainer: {
    marginTop: 15
  },
  hours: {
    marginTop: 12,
  },
  open: {
    ...Fonts.type.bold,
    fontSize: 17,
    marginTop: 10,
    marginRight: 5,
    marginBottom: 5
  },
  dot: {
    ...Fonts.type.bold,
    fontSize: 18,
    marginRight: 5,
  },
  separator: theme => ({
    borderBottomWidth: 1,
    marginVertical: 15,
    borderColor: theme.colors.borderColorFour,
  }),
  button: {
    marginTop: 15,
  },
  point: {
    width: 15,
    height: 15,
    borderRadius: 15,
    backgroundColor: Colors.true_green
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  timeslotText: theme => ({
    fontSize: Fonts.size.regularSmall,
    color: theme.colors.textColorFive,
  }),
  locationText: theme => ({
    fontSize: Fonts.size.regularSmall,
    color: theme.colors.seeBillColor,
    marginBottom: -2
  }),
  row: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  calendarText: theme => ({
    color: theme.colors.textColorFive,
    fontSize: Fonts.size.regularSmall,
    marginBottom: 8
  }),
  calendarItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center'
  }
})
